<div menuSystem [cerrixTab]="tab">
    <div menuItemId="menuItemDevManagement" [attr.name]="'devManagement.menuDevManagement' | t" menuicon="fas fa-code" menusystemsubmenu>
        <div menuItemId="menuItemImport" [attr.name]="'devManagement.menuImport' | t" menuicon="fas fa-file-import" menusystemitem>
            <dev-import></dev-import>
        </div>
        <div menuItemId="menuItemExport" [attr.name]="'devManagement.menuExport' | t" menuicon="fas fa-file-export" menusystemitem>
            <dev-export></dev-export>
        </div>
        <div menuItemId="menuItemCustomRoles" [attr.name]="'devManagement.menuCustomRoles' | t" menuicon="fas fa-user-tag" menusystemitem>
            <dev-cerrixrole></dev-cerrixrole>
        </div>
        <div menuItemId="menuItemPowerBi" [attr.name]="'devManagement.menuPowerBi' | t" menuicon="fas fa-chart-area" menusystemitem>
            <dev-powerbi></dev-powerbi>
        </div>
        <div menuItemId="menuItemExecutables" [attr.name]="'devManagement.menuExecutables' | t" menuicon="fas fa-terminal" menusystemitem>
            <dev-code-executions></dev-code-executions>
        </div>
        <div menuItemId="menuItemActions" [attr.name]="'devManagement.menuActions' | t" menuicon="far fa-angle-double-right" menusystemitem>
            <dev-actions></dev-actions>
        </div>
        <div menuItemId="menuItemApplicationKeys" [attr.name]="'devManagement.menuApplicationKeys' | t" menuicon="far fa-key" menusystemitem>
            <dev-keys></dev-keys>
        </div>
    </div>
</div>
